import { Flex } from '@components/Flex';
import { styled } from '@styledComponents';
import { Button } from '@components/Button';
import { Text } from '@components/typography';
import { JoykitIcon } from '@components/JoykitIcon';
import { ButtonNoneStyled } from '@components/ButtonNoneStyled';
import { animationTransition } from '@utils/animationTransition';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { ButtonTextStyles, Display2Styles } from '@components/typography/interVariants';

export const StyledWrapper = styled(Flex)`
  gap: ${themeSpace(6)};
  border-radius: ${themeSpace(9)};
  box-shadow: 0px 0px 0px 1px ${themeColor('mono3')}, 0px 9px 36px -30px rgba(0, 0, 0, 0.04), 0px 10px 60px -20px rgba(44, 41, 37, 0.03),
    0px 3px 8px 0px rgba(0, 0, 0, 0.03);
`;

export const StyledEventTypesMobile = styled(Flex)`
  display: flex;
  gap: ${themeSpace(3)};
  margin-bottom: ${themeSpace(5)};
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const StyledEventTypes = styled(Flex)<{ height: number; minWidth: number }>`
  height: ${({ height }) => height}px;
  min-width: ${({ minWidth }) => minWidth}px;
  width: fit-content;
  display: none;
  border-right: 1px solid ${themeColor('mono4')};
  ${themeMediaQuery('sm')} {
    display: flex;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  border: none;
  padding: 0;
  align-items: center;

  ${Display2Styles};

  :focus {
    outline: none;
  }

  :focus::placeholder {
    color: transparent;
  }

  ${themeMediaQuery('below_sm')} {
    font-size: ${themeSpace(5)};
    line-height: ${themeSpace(6)};
  }
`;

export const StyledJoykitIcon = styled(JoykitIcon)`
  display: none;
  ${themeMediaQuery('sm')} {
    display: flex;
  }
`;

export const StyledJoykitIconMobile = styled(JoykitIcon)`
  display: flex;
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const FilterCta = styled(Button)<{ active: boolean }>`
  ${ButtonTextStyles};
  border-radius: 20px;
  height: ${themeSpace(8)};
  padding: 0 ${themeSpace(5)};
  color: ${({ active }) => (active ? themeColor('white') : themeColor('mono12'))};
  background-color: ${({ active }) => (active ? themeColor('mono12') : 'transparent')};
  border: 2px solid ${themeColor('mono12')};
  &:hover {
    background-color: ${({ active }) => (active ? themeColor('mono12') : 'transparent')};
    border: 2px solid ${themeColor('mono12')};
  }
`;

export const StyledSubmitButton = styled(ButtonNoneStyled)`
  border-radius: 50%;
  padding: ${themeSpace(2)};
  background-color: ${themeColor('mono1')};
  transition: ${animationTransition('background-color')};
  ${themeMediaQuery('sm')} {
    padding: ${themeSpace(5)};
  }
  &:hover {
    background-color: ${themeColor('mono12')};
  }
`;

export const ErrorDetail = styled(Text)`
  color: ${themeColor('red5')};
  margin-top: ${themeSpace(7)};
  margin-bottom: ${themeSpace(5)};
`;
